// extracted by mini-css-extract-plugin
export const close = "CloseButton-module--close--SJfBm";
export const hasText = "CloseButton-module--hasText--eziuJ";